<template>
  <div class="req-track">
    <div class="chart_wrap">
      <div class="charts_line">
        <e-charts
          style="width: 100%"
          :options="lineOptions"
          auto-resize
        ></e-charts>
      </div>
      <div class="charts_bar">
        <e-charts style="width: 100%" :options="options" auto-resize></e-charts>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";

import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";
import theme from "./theme";

// const MonthHeader = [
//   "一月",
//   "二月",
//   "三月",
//   "四月",
//   "五月",
//   "六月",
//   "七月",
//   "八月",
//   "九月",
//   "十月",
//   "十一月",
//   "十二月",
// ];

export default {
  name: "GraphRequestTracking",
  components: { ECharts },
  props: {
    data: {
      type: Array,
    },
  },
  computed: {
    options() {
      const tableHeaderMap = {
        countProcessed: this.$lange == "en" ? "Processing" : "处理中",
        // countFinish: "已完成",
        // countObservation: "观察中",
        // countClose: "已关闭",
        countCreate: this.$lange == "en" ? "Total Requests" : "总请求",
      };
      console.log("data", this.data);
      const labels = Object.values(tableHeaderMap);
      // 只保留 处理中和总请求
      const newData = this.data.filter((item) =>
        labels.includes(item["month-header"])
      );

      const series = newData.map((item) => {
        const name = item["month-header"];
        const data = Array(12)
          .fill(0)
          .map((key, idx) => ({
            label: this.MonthHeader[idx],
            value: item[`month-${idx + 1}`],
          }));
        return {
          name,
          type: "bar",
          data,
          label: {
            show: true,
            position: "top",
          },
        };
      });
      const legendData = newData.map((item) => item["month-header"]);
      return {
        ...theme,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: legendData,
          top: 6,
          left: 32,
        },
        grid: {
          left: 16,
          right: 16,
          containLabel: true,
          show: true,
        },
        xAxis: {
          data: this.MonthHeader,
        },
        yAxis: {},
        series,
      };
    },
    lineOptions() {
      const series = this.data.map((item) => {
        const name = item["month-header"];
        const data = Array(12)
          .fill(0)
          .map((key, idx) => ({
            label: this.MonthHeader[idx],
            value: item[`month-${idx + 1}`],
          }));
        return { name, type: "line", data };
      });
      const legendData = this.data.map((item) => item["month-header"]);

      return {
        ...theme,
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legendData,
          top: 6,
          left: 32,
        },
        grid: {
          left: 16,
          right: 32,
          containLabel: true,
          show: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.MonthHeader,
        },
        yAxis: {
          type: "value",
        },
        series,
      };
    },
  },
  data() {
    return {
      count: 0,
      MonthHeader: [
        this.$lange == "en" ? "Jan" : "一月",
        this.$lange == "en" ? "Feb" : "二月",
        this.$lange == "en" ? "Mar" : "三月",
        this.$lange == "en" ? "Apr" : "四月",
        this.$lange == "en" ? "May" : "五月",
        this.$lange == "en" ? "Jun" : "六月",
        this.$lange == "en" ? "Jul" : "七月",
        this.$lange == "en" ? "Aug" : "八月",
        this.$lange == "en" ? "Sep" : "九月",
        this.$lange == "en" ? "Oct" : "十月",
        this.$lange == "en" ? "Nov" : "十一月",
        this.$lange == "en" ? "Dec" : "十二月",
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.chart_wrap {
  display: flex;
  box-sizing: border-box;
}

.charts_line {
  width: 614px;
  border: 1px solid #aaa7a788;
}
.charts_bar {
  width: calc(100% - 614px);
  margin-left: 8px;
  border: 1px solid #aaa7a788;
}

.req_category {
  display: flex;
}
.category_item {
  width: 50%;
}

.category_item:not(:first-child) {
  margin-left: 8px;
}
.no_data {
  text-align: center;
  color: #86898f;
  /* align-self: center; */
  transform: translateY(-50%);
  position: relative;
  top: 50%;
  left: 0;
}
</style>
